var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "filter-list" }, [
        _c("div", { staticClass: "filter-item middle-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        子流程\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择",
                      filterable: ""
                    },
                    on: { change: _vm.onsubProcessChange },
                    model: {
                      value: _vm.filter.subProcess.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filter.subProcess, "value", $$v)
                      },
                      expression: "filter.subProcess.value"
                    }
                  },
                  _vm._l(_vm.filter.subProcess.options, function(item) {
                    return _c("el-option", {
                      key: item.srcId,
                      attrs: { value: item.srcId, label: item.name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item small-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        子流程状态\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择",
                      filterable: ""
                    },
                    on: { change: _vm.onsubProcessStatusChange },
                    model: {
                      value: _vm.filter.subProcessStatus.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filter.subProcessStatus, "value", $$v)
                      },
                      expression: "filter.subProcessStatus.value"
                    }
                  },
                  _vm._l(_vm.filter.subProcessStatus.options, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      class: _vm.$util.getRiskLevelBgColor(item.color),
                      attrs: { value: item.code, label: item.name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item middle-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        节点\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择",
                      filterable: ""
                    },
                    on: { change: _vm.onNodeChange },
                    model: {
                      value: _vm.filter.node.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filter.node, "value", $$v)
                      },
                      expression: "filter.node.value"
                    }
                  },
                  _vm._l(_vm.filter.node.options, function(item) {
                    return _c("el-option", {
                      key: item.srcId,
                      attrs: { value: item.srcId, label: item.name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item small-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        节点状态\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择",
                      filterable: ""
                    },
                    on: { change: _vm.onNodeStatusChange },
                    model: {
                      value: _vm.filter.nodeStatus.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filter.nodeStatus, "value", $$v)
                      },
                      expression: "filter.nodeStatus.value"
                    }
                  },
                  _vm._l(_vm.filter.nodeStatus.options, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      class: _vm.$util.getRiskLevelBgColor(item.color),
                      attrs: { value: item.code, label: item.name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item middle-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        检查内容\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-input-wrapper" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  on: { change: _vm.onSearchChange },
                  model: {
                    value: _vm.filter.search.value,
                    callback: function($$v) {
                      _vm.$set(_vm.filter.search, "value", $$v)
                    },
                    expression: "filter.search.value"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item small-filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        检查状态\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择",
                      filterable: ""
                    },
                    on: { change: _vm.onSearchStatusChange },
                    model: {
                      value: _vm.filter.searchStatus.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filter.searchStatus, "value", $$v)
                      },
                      expression: "filter.searchStatus.value"
                    }
                  },
                  _vm._l(_vm.filter.searchStatus.options, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      class: _vm.$util.getRiskLevelBgColor(item.color),
                      attrs: { value: item.code, label: item.name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "table", staticClass: "table-box" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.standardDangerData,
                "span-method": _vm.dangerSpanMethod,
                border: "",
                height: "360",
                "header-cell-class-name": "risk-table-header",
                "cell-class-name": "cell-class"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "#",
                  prop: "index",
                  width: "50",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subSystemName",
                  label: "子系统",
                  width: "",
                  "show-overflow-tooltip": true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "processName", label: "流程", width: "" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subProcessName",
                  label: "子流程",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "danger-desc-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "danger-desc",
                              on: {
                                click: function($event) {
                                  return _vm.onSubProcessNameClick(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.subProcessName) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subProcessScore",
                  label: "子流程状态",
                  width: "",
                  "show-overflow-tooltip": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: _vm.$util.getRiskLevelColor(
                              scope.row.subProcessLevelColor
                            )
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.subProcessScore) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "subNodeName", label: "节点", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subNodeStatus",
                  label: "节点状态",
                  width: "",
                  "show-overflow-tooltip": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: _vm.$util.getRiskLevelColor(
                              scope.row.subNodeLevelColor
                            )
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.subNodeStatus) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "PROBLEM",
                  label: "检查内容",
                  width: "",
                  "show-overflow-tooltip": true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "SCORE",
                  label: "检查状态",
                  width: "",
                  "show-overflow-tooltip": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: _vm.$util.getRiskLevelColor(
                              scope.row.LEVEL_COLOR
                            )
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.SCORE) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "REF_REPORT_COUNT",
                  label: "关联任务单",
                  width: "",
                  "show-overflow-tooltip": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "danger-desc-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "danger-desc",
                              on: {
                                click: function($event) {
                                  return _vm.takeReportData(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.REF_REPORT_COUNT) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.refReportVisble,
            title: _vm.title,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.refReportVisble = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.reportData,
                border: "",
                height: "360",
                "header-cell-class-name": "risk-table-header",
                "cell-class-name": "cell-class"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  prop: "index",
                  width: "50",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "summary",
                  label: "关联工作单",
                  width: "200 px",
                  "show-overflow-tooltip": true,
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: {
                              type: "primary",
                              underline: false,
                              target: "_blank",
                              href: _vm.$util.buildSmsActivityDetailUrl(
                                scope.row.activityId
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.summary) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "checkScore", label: "检查评分", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: _vm.calcRiskColor(scope.row.checkScore),
                            attrs: { align: "center" }
                          },
                          [_c("b", [_vm._v(_vm._s(scope.row.checkScore))])]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "groupMembers",
                  label: "检查人员",
                  width: "200 px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "inspectedUnitOrg",
                  label: "被检查单位",
                  width: ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "inspectedPlace", label: "检查地点", width: "" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "completeDate",
                  label: "结案时间",
                  width: "100 px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.refReportVisble = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c71df6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c71df6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/process/KeyProcessProblem.vue
// module id = null
// module chunks = 